<script lang="ts">
    import { spaLink } from "../../../../functionTools/routing"
    import AnimatingMoreArrow from "../../../widgets/AnimatingMoreArrow.svelte"

    let {
        path,
        text,
        activated,
        colored,
        page_ref,
    }: {
        path?: string
        text: string
        activated?: boolean
        colored?: boolean
        page_ref?: string
    } = $props()

    let active = $state(false)
</script>

<a href={path} use:spaLink onmouseenter={() => (active = true)} onmouseleave={() => (active = false)} class:colored>
    <span>{text}</span>
    {#if !activated}
        <AnimatingMoreArrow {active} height={24} />
    {/if}
</a>

<style lang="less">
    @import "../../../../css/variables.less";
    a {
        color: var(--dark-100);
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 1.6rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: all 0.3s ease-in-out;
        &:hover {
            color: var(--brand-100);
            padding-left: 0.6rem;
        }
        &.colored {
            color: var(--brand-100);
        }
        @media @max-mobile-header {
            font-size: 1rem;
        }
    }
</style>
